import "../styles.css";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import TestWrapper from "../../TestWrapper";

export default function DesktopWearGlasses({ answer, ...props }) {
  const age = props?.test?.steps["age"]?.result?.value?.age || 0;
  const { t } = useTranslation();
  const [mode, setMode] = useState("wearGlasses");
  const [response, setResponse] = useState({});

  const questionText = t("Do you wear glasses?")
  const questionText2 = t("Let us know if you use prescription glasses so we can personalize your vision test experience.")

  const answerText1 = t("Yes");
  const answerText2 = t("No");

  const buttonAction = (val) => {
    if (mode === "wearGlasses") {
      const wearGlasses = val === answerText1 ? "yes" : "no";
      setResponse({ wearGlasses });

      if (age >= 40 && wearGlasses === "yes") {
        setMode("greaterThan40");
      } else {
        answer({ wearGlasses });
        return;
      }
    } else if (mode === "greaterThan40") {
      const visionPurpose = val;
      const updatedResponse = { ...response, visionPurpose };

      answer(updatedResponse);
      return;
    }
  };
  return (
    <TestWrapper image={`../images/test/012.jpg`}>
      {mode === "wearGlasses" && (
        <>
          <h2>{questionText}</h2>
          <h4>{questionText2}</h4>

          <div className="multiple-buttons">
            <div
              onClick={() => {
                buttonAction(answerText1);
              }}
              className="button-default"
            >
              {answerText1}
            </div>

            <div
              onClick={() => {
                buttonAction(answerText2);
              }}
              className="button-default"
            >
              <div>{answerText2}</div>
            </div>
          </div>
        </>
      )}
      {mode === "greaterThan40" && (
        <>
          <h2>{t("What do you use your glasses for?")}</h2>
          <h4>{t("Please select whether your glasses are for near vision, distance vision, or both.")}</h4>

          <div className="multiple-buttons">
            <div
              onClick={() => {
                buttonAction("near");
              }}
              className="button-default"
            >
              {t("Near")}
            </div>

            <div
              onClick={() => {
                buttonAction("far");
              }}
              className="button-default"
            >
              <div>{t("Far")}</div>
            </div>
            <div
              onClick={() => {
                buttonAction("both");
              }}
              className="button-default"
            >
              <div>{t("Both")}</div>
            </div>  
          </div>
        </>
      )}
    </TestWrapper>
  );
}
